import { render, staticRenderFns } from "./ButtonPlug.vue?vue&type=template&id=43fc4739"
import script from "./ButtonPlug.vue?vue&type=script&lang=js"
export * from "./ButtonPlug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports